


const heart_circle = document.querySelectorAll('.heart_circle')
const heart_solid = document.querySelectorAll('.heart_solid')

function remove_heart_circle(el) {
    el.classList.remove('hide_icon_favored')
}
function add_heart_circle(el) {
    el.classList.add('hide_icon_favored')
}
function showSolid(e) {
    add_heart_circle(e.target)
    var parent = e.target.parentNode
    var heart_solid_clicked = parent.querySelector('.heart_solid')
    remove_heart_circle(heart_solid_clicked)
}
function showCircle(e) {
    add_heart_circle(e.target)
    var parent = e.target.parentNode
    var heart_circle_clicked = parent.querySelector('.heart_circle')
    remove_heart_circle(heart_circle_clicked)
}
heart_circle.forEach((heart) => {
    heart.addEventListener('click', async (e) => {
        var customerId = sessionStorage.getItem('customerId');
        if (customerId) {
            const productId = e.target.getAttribute('data-productid');
            const addProduct = await addProducts(customerId, productId)
            if (addProduct.status == 200) {
                listProductFavoredExist()
                showSolid(e)
            }
        } else {
            window.location.href = "/account";
        }
    })
})

heart_solid.forEach((heart) => {
    heart.addEventListener('click', async (e) => {
        var customerId = sessionStorage.getItem('customerId');
        const productId = e.target.getAttribute('data-productid');
        const removeProduct = await removeProducts(customerId, productId)
        if (removeProduct.status == 200) {
            listProductFavoredExist()
            showCircle(e)
        }
    })
})

async function getProducts(id) {
   try {
       const data = {
           customerId: id
       }
       const response = await fetch(`https://api-frete.vercel.app/favored/products`, {
           method: 'POST',
           body: JSON.stringify(data),
           headers: {
               'Content-Type': 'application/json'
           }
       })
       if (response.status == 200) {
           const result = await response.json()
           return result
       }
   } catch (error) {
       return undefined
   }
}

async function processIcons() {
    const icons_favored = document.querySelectorAll('.icons_favored');
    var id = sessionStorage.getItem('customerId');
    if (id) {
        const productIdFavored = await getProducts(id);
        if (productIdFavored && productIdFavored.status === 200) {
            const favoredProductIds = productIdFavored.data.map(data => data);
            icons_favored.forEach(e => {
                const productId = e.getAttribute('data-productid');
                if (favoredProductIds.includes(productId)) {
                    const solid_circle = e.querySelector('.heart_circle');
                    const heart_solid = e.querySelector('.heart_solid');
                    add_heart_circle(solid_circle);
                    remove_heart_circle(heart_solid);
                }
            });
        }
    }
}


processIcons();

async function addProducts(customerId, productId) {
    const data = {
        customerId: customerId,
        productId: productId
    }
    const response = await fetch(`https://api-frete.vercel.app/favored/add`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json'
        }
    })
    if (response.status == 200) {
        const result = await response.json()
        return result
    }
}

async function removeProducts(customerId, productId) {
    const data = {
        customerId: customerId,
        productId: productId
    }
    const response = await fetch(`https://api-frete.vercel.app/favored/remove`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json'
        }
    })
    if (response.status == 200) {
        const result = await response.json()
        return result
    }
}


async function listProductFavoredExist() {
    const qty_favorite = document.querySelector('.qty_favorite')
    var customerId = sessionStorage.getItem('customerId');
    const data = {
        customerId: customerId
    }
    const response = await fetch(`https://api-frete.vercel.app/favored/products`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json'
        }
    })
    if (response.status == 200) {
        const result = await response.json()
        if (result.data.length > 0) {
            qty_favorite.innerHTML = result.data.length
            qty_favorite.classList.add('qty_favorite_hide')
            document.querySelector('.heart_solid_icon').classList.add('fa-solid')
        } else {
            qty_favorite.classList.remove('qty_favorite_hide')
            document.querySelector('.heart_solid_icon').classList.remove('fa-solid')
            document.querySelector('.heart_solid_icon').classList.add('fa-regular')
        }
    }
}

window.addEventListener('load', async function() {
  setTimeout(async function() {
     await listProductFavoredExist()
  }, 3000);
});
